import React, { useContext, useRef } from 'react';
import DataGrid, {
  Button as GridButton, Column, DataGridRef, Editing, Toolbar,
  Item as GridItem, FilterRow, Form, Format, Lookup, Pager, Paging, Popup,
  HeaderFilter
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react';
import { GroupItem, Item } from "devextreme-react/form";
import { dataGridErrorHandling } from '../../utils/errorHandling';
import { useEntiDataSource } from '../../datasources/EntiDataSource';
import EnteEditPopup, { EnteEditPopupHandle } from '../../components/enteEdit/enteEditPopup';


export default function Enti() {
  const dataSource = useEntiDataSource();
  const enteEditPopupRef = useRef<EnteEditPopupHandle>(null);
  const gridRef = useRef<DataGridRef>(null);

  const refreshGrid = () => { gridRef.current?.instance().refresh(); }

  function openEnteEditPopup(e: any) {
    enteEditPopupRef.current?.edit(e.row.key, `${e.row.data.nome}`);
  }

  function openEnteNewPopup(e: any) {
    enteEditPopupRef.current?.new();
  }

  return (
    <React.Fragment>
      <h2 className={'content-block'}>Enti</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>

          <DataGrid
            dataSource={dataSource}
            onDataErrorOccurred={dataGridErrorHandling}
            ref={gridRef}
            onRowUpdating={function (e) {
              e.newData = Object.assign({}, e.oldData, e.newData);
            }}
          >
            <Editing
              allowUpdating={true}
              allowAdding={true}
              allowDeleting={true}>
            </Editing>
            <HeaderFilter visible={true} allowSearch={true} />
            <Column type='buttons' alignment='left'>
              <GridButton name="edit" onClick={openEnteEditPopup} />
              <GridButton name="delete" />
            </Column>
            <Column dataField={'id'} width={90} allowEditing={false} visible={false} />
            <Column dataField={'nome'} caption={'Nome'} />

            <Toolbar>
              <GridItem location="after">
                <Button
                  icon='add'
                  //hint='Invia un invito per un nuovo utente'
                  stylingMode="text"
                  onClick={openEnteNewPopup}
                />

              </GridItem>
            </Toolbar>
          </DataGrid>


        </div>
      </div>

      <EnteEditPopup ref={enteEditPopupRef} onDataChanged={refreshGrid} />
    </React.Fragment>
  )
}
